<!--<div class="container">

  <h1>Angular Google Map Get Current Location Example - ItSolutionStuff.com</h1>

  <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
    <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"> </agm-marker>
  </agm-map>

  <h5>Address: {{address}}</h5>
  <div>Latitude: {{latitude}}</div>
  <div>Longitude: {{longitude}}</div>-->


<div class="container">

  <div class="row d-flex w-100 pb-3">
    <div class="col-12">
      <button type="button" class="btn btn-primary" [routerLink]="['/cardPromos',selectedCardId, lastPage]">
        &nbsp;<span class="glyphicon glyphicon-triangle-left" style="color: yellow;"></span> Regresar&nbsp;&nbsp;&nbsp;
      </button>
    </div>
  </div>

</div>

  <nav>
    <div *ngIf="showMap" #mapContainer id="map"></div>
    <img *ngIf="!showMap" src="assets/img/mapa_gris.png" width="100%">
  </nav>

<!--
</div>
-->
